import React from 'react';
import { Link } from 'react-router-dom';

import { paths } from '../../../../constants';
import { getClickAttrs } from '../../Analytics/gtag';

import Img from '../../Img';
import { clickCategories } from '../../../utils/analytics';
import { navigationIDs } from '../../Analytics/testIDConfig';

import styles from '../header.scss';

const UtrAppLogo = ({ onClick }) => {
    return (
        <Link
            className={styles.utrLogo}
            to={paths.home}
            onClick={onClick}
            {...getClickAttrs({
                category: clickCategories.HEADER,
                context: `UTR icon`,
                location: 'Top header navigation',
                testid: `${navigationIDs.logo.component}-${navigationIDs.logo.location}-${navigationIDs.logo.id}`,
            })}
        >
            <Img src={'/img/utr_sports/utr-sports-logo.svg'} />
        </Link>
    );
};

export default UtrAppLogo;
